import { ModelNumberLookupResponse } from '../../models/services/api/queryModelNumber';
import { get } from './client';

export const queryModelNumber = async (
  modelNumber: string,
  signal?: AbortSignal,
): Promise<ModelNumberLookupResponse> => {
  const brandCode = import.meta.env.VITE_BRAND_CODE;
  try {
    return await get<ModelNumberLookupResponse>(
      `/appliance-lookup?brand=${brandCode}&modelNumber=${modelNumber}`,
      { signal },
    );
  } catch (_) {
    return { appliances: [] };
  }
};
